// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__3PmkM","titleWrap":"styles_titleWrap__1bleH","title":"styles_title__SxCLg","icon":"styles_icon__whtJe"};